import { render } from "./App.vue?vue&type=template&id=65ed84f7&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=65ed84f7&lang=scss"

import exportComponent from "/Users/zachbiri/Dev/mine/placeholder/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47+webpack@5.76.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__